import PropTypes from 'prop-types';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import plTheme from './theme';

const PlThemeProvider = ({ children, theme, ...props }) => {
  return (
    <MuiThemeProvider theme={plTheme.mui}>
      <ThemeProvider
        {...props}
        theme={{
          ...plTheme,
          ...theme,
        }}
      >
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};
PlThemeProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};
PlThemeProvider.default = {
  theme: {},
};
export default PlThemeProvider;
export { plTheme };
